import React from "react";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";
import { trackEvent } from "../utils/analytics";

const Contact = () => {
  const socialLinks = [
    {
      href: "https://github.com/perkypearl",
      icon: <FaGithub />,
    },
    {
      href: "https://www.linkedin.com/in/perkypearl",
      icon: <FaLinkedin />,
    },
    {
      icon: <FaInstagram />,
      href: "https://www.instagram.com/precisepearl",
    },
    {
      href: "https://x.com/precise_pearl",
      icon: <FaSquareXTwitter />,
    },
  ];

  return (
    <section className="section" id="contact">
      <div className="container lg:grid lg:grid-cols-2 lg:items-stretch">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-12 lg:mb-0 lg:flex lg:flex-col"
        >
          <h2 className="headline-2 lg:max-w-[12ch]">Connect me for Collaboration</h2>
          <p className="text-zinc-400 mt-3 mb-8 max-w-[50ch] lg:max-w-[30ch]">
            I am open for collaboration and ready to work on new projects. Feel
            free to connect with me on social media.
          </p>

          {/* Social Icons with Sequential Pop-up effect when they enter the view */}
          <motion.div
            className="flex items-center gap-2 mt-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            {socialLinks.map(({ href, icon }, key) => (
              <motion.a
                href={href}
                key={key}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 grid place-items-center ring-inset ring-2 ring-zinc-50/5 rounded-lg transition-[background-color,color] hover:bg-zinc-50 hover:text-zinc-950 active:text-zinc-50/80"
                onClick={() => {
                  if (href.includes("github")) {
                    trackEvent("github_profile_click", { link_url: href, link_type: "social" });
                  } else if (href.includes("linkedin")) {
                    trackEvent("linkedin_profile_click", { link_url: href, link_type: "social" });
                  } else {
                    trackEvent("contact_click", { link_url: href, link_type: "social" });
                  }
                }}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{
                  delay: 0.2 + key * 0.2, // Delay each icon by 0.2 seconds
                  duration: 0.6,
                }}
                viewport={{ once: true }}
              >
                {icon}
              </motion.a>
            ))}
          </motion.div>
        </motion.div>

        <motion.form
          action="https://getform.io/f/bkkkvvmb"
          method="POST"
          className="xl:pl-8 2xl:pl-20"
          onSubmit={() => trackEvent("contact_click", { link_url: "https://getform.io/f/bkkkvvmb", link_type: "contact_form" })}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="md:grid md:items-center md:grid-cols-2 md:gap-2">
            <motion.div
              className="mb-4"
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <label htmlFor="name" className="label">
                Name:
              </label>
              <input
                type="text"
                name="name"
                id="name"
                autoComplete="name"
                placeholder="Pearl"
                className="text-field"
              />
            </motion.div>

            <motion.div
              className="mb-4"
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <label htmlFor="email" className="label">
                Email:
              </label>
              <input
                type="text"
                name="email"
                id="email"
                autoComplete="email"
                placeholder="perkypearl.dev@gmail.com"
                className="text-field"
              />
            </motion.div>
          </div>

          <motion.div
            className="mb-4"
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <label htmlFor="message" className="label">
              Message:
            </label>

            <textarea
              name="message"
              id="message"
              placeholder="Hi!"
              required
              className="text-field resize-y min-h-32 max-h-80"
            ></textarea>
          </motion.div>

          <motion.button
            type="submit"
            className="btn btn-primary [&]:max-w-full w-full justify-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Submit
          </motion.button>
        </motion.form>
      </div>
    </section>
  );
};

export default Contact;